import { render, staticRenderFns } from "./PageButtonTest.vue?vue&type=template&id=d072392e&scoped=true&"
import script from "./PageButtonTest.vue?vue&type=script&lang=js&"
export * from "./PageButtonTest.vue?vue&type=script&lang=js&"
import style0 from "./PageButtonTest.vue?vue&type=style&index=0&id=d072392e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d072392e",
  null
  
)

export default component.exports